module.exports = __webpack_public_path__ + "img/fyt_p6.8300fb98.png";